module.exports = __webpack_public_path__ + "static/media/slide2.029fbd31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupIncludes/assets/slide2.jpg
// module id = 540
// module chunks = 0